var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

(function($, global) {
    "use strict";

    $.extend(MDB.Charts, {
        dashboardGridSize: 50,
        useAutoLayout: false,
        widgetSeriesTooltipTemplate: '# if(!/^\\s+$/.test(series.name)) { # #= series.name #: # }#',

        setupGlobalChartData: function (globalData) {
            globalData = globalData || {};
            
            MDB.Charts.registerGlobalData = function (data, dataKey) {
                dataKey = dataKey || MDB.guid();
                globalData[dataKey] = data;
                return dataKey;
            };
            
            MDB.Charts.getGlobalData = function (dataKey) {
                return globalData[dataKey];
            }
        },
        // register widgets
        register: function(id, type, config) {
            var widget = $('#widget-' + id);
            MDB.Charts.registerFunctions(widget, id, type, config);
            // MDB.Charts.setupInitialWidgetSize(widget, config);
            
            if (!MDB.Charts.useAutoLayout){
                MDB.Charts.setupWidgetResizing(widget, config);
                MDB.Charts.setupWidgetMoving(widget, config);   
            }
            
            var reload = widget.data('reload');
            return reload !== undefined ? reload() : null;
        },
        registerMulti: function (arr) {
            var promises = [];
            // .widget | #widget-{id}
            for (var i = 0; i < arr.length; i++) {
                promises.push(MDB.Charts.register(arr[i].id, arr[i].type, arr[i]));
            }

            if (MDB.Charts._onresize_registered) return;
            MDB.Charts._onresize_registered = true;
            $('.content').css('overflow', 'visible');
            //(window).on('resize', MDB.Charts._resizeContentArea);
            //setTimeout(MDB.Charts._resizeContentArea, 0);

            MDB.Charts.setupWidgetFramedModalTrigger();

            $.when.apply($, promises).always(function () {
                $(document).trigger('mdbDashboard.loaded');
                
                if (MDB.Charts.useAutoLayout){
                    //Correct widget aspect ratios
                    MDB.Charts.rescaleAllWidgets();
                    $(document).on('mdbDashboard.reloaded', MDB.Charts.rescaleAllWidgets);
                    $(window).on('resize', _.debounce(MDB.Charts.rescaleAllWidgets, 500));
                }
                
                try {
                    document.dispatchEvent(new MessageEvent('FreezerFire'));
                } catch(e) {
                    // IE11- doesn't like this document.dispatchEvent
                }
            });
			// fallback
			setTimeout(function() {
				try {
                    document.dispatchEvent(new MessageEvent('FreezerFire'));
                } catch(e) {
                    // IE11- doesn't like this document.dispatchEvent
                }
			}, 1000 * 60 * 2.5);
        },
        initializeWidgetGroups: function(){
            //Initialize each individual group
            var widgetGroupNodeList = document.querySelectorAll('.widget-group');
            
            //IE does not support NodeList.forEach(...)
            //https://developer.mozilla.org/en-US/docs/Web/API/NodeList
            Array.prototype.forEach.call(widgetGroupNodeList, function(widgetGroup){
                widgetGroup = $(widgetGroup);

                MDB.Charts.setupWidgetGroupResizing(widgetGroup);
                MDB.Charts.setupWidgetGroupMoving(widgetGroup);
                MDB.Charts.setupWidgetGroupDelete(widgetGroup); 
            });
        },

        widgetMovedByExternalForce:function(id, x, y, w, h) {
            var widget = $('#widget-' + id);
            if (widget.length === 0) {
                // widget not found
                return;
            }
            var gridBlockSize = MDB.Charts.dashboardGridSize;

            var id = widget.data('id');
            var box = widget.find('.box');

            var newW = w * gridBlockSize;
            var newH = h * gridBlockSize;

            var oldW = parseInt(box.css('width'), 10);
            var oldH = parseInt(box.css('height'), 10);

            widget.css({ left: x * gridBlockSize, top: y * gridBlockSize });
            if (oldH !== newH || oldW !== newW) {
                box.css({ width: newW, height: newH });
                setTimeout(function() {
                    var reload = widget.data('reload');
                    reload();
                }, 0);
            }
            MDB.Charts.storeUpdatedPositionFromDOM(widget, true);
        },
        storeUpdatedPosition: function (id, x, y, w, h) {
            /*return $.ajax({
                type: 'POST',
                data: {},
                url: '/api/widget/position?id='+id+'&x=' + x + '&y=' + y + '&w=' + w + '&h=' + h
            });*/
            return MDB.callDashboardHub(function (hub) {
                return hub.server.updateWidgetPosition(id, x, y, w, h);
            });
        },
        storeWidgetGroupUpdatedPositionFromDOM: function(widgetGroup){
            var id = widgetGroup.data('id');
            var box = widgetGroup.find('.box');
            var position = widgetGroup.position();

            //SignalR does not like receiving floating point numbers instead of integers
            var x = Math.ceil(position.left);
            var y = Math.ceil(position.top);
            var w = parseInt(box.css('width'), 10);
            var h = parseInt(box.css('height'), 10);

            //Guid widgetGroupId, int x, int y, int w, int h
            return MDB.callDashboardHub(function(hub){
                return hub.server.updateWidgetGroupPosition(id, x, y, w, h);
            });
        },

        storeUpdatedPositionFromDOM: function (widget, dontUpdateServer) {
            var id = widget.data('id');
            var box = widget.find('.box');
            var position = widget.position();

            var x = position.left;//parseInt(widget.css('left'), 10);
            var y = position.top;//parseInt(widget.css('top'), 10);
            var w = parseInt(box.css('width'), 10);
            var h = parseInt(box.css('height'), 10);

            var gridBlockSize = MDB.Charts.dashboardGridSize;
            x = Math.ceil(x / gridBlockSize);
            y = Math.ceil(y / gridBlockSize);
            w = Math.ceil(w / gridBlockSize);
            h = Math.ceil(h / gridBlockSize);
            if (!dontUpdateServer) {
                return MDB.Charts.storeUpdatedPosition(id, x, y, w, h);
            }
        },
        sendWidgetToTop:function(widget) {
            if (!widget.hasClass('dashboard-widget-top')) {
                $('.dashboard-widget-top').removeClass('dashboard-widget-top');
                widget.addClass('dashboard-widget-top');
            }
        },
        setupInitialWidgetSize: function (widget, config) {
            /*
            var gridBlockSize = MDB.Charts.dashboardGridSize;
            var x = config.x * gridBlockSize,
                y = config.y * gridBlockSize,
                w = config.w * gridBlockSize,
                h = config.h * gridBlockSize;
            w = Math.max(w, gridBlockSize);
            h = Math.max(h, gridBlockSize);

            var box = widget.find('.box');

            widget.css({
                position: 'absolute',
                left: x + 'px',
                top: y + 'px'
            });
            box.css({
                overflow:'hidden',
                width: w + 'px',
                height: h + 'px'
            });
            */
        },
        setupWidgetGroupDelete: function(widgetGroup){
            widgetGroup.on('click', '[data-widget-group="remove"]', function(){
                var id = widgetGroup.data('id')
                    , name = widgetGroup.data('name');

                MDB.prompt(
                    MDB.loadResourceString('WidgetGroup_Delete_Prompt_Title'),
                    sprintf(MDB.loadResourceString('WidgetGroup_Delete_Prompt_Body'), name),
                    function(ok){
                        //User changed their mind; back out early
                        if(!ok) return;

                        MDB.sendAjaxRequest(
                            '/WidgetGroup/Delete/' + id,
                            undefined,
                            'DELETE'
                        ).done(function(){
                            //Slowly slide up our box; then remove the group
                            widgetGroup.find('.box').slideUp({
                                complete: function(){
                                    widgetGroup.remove();
                                }
                            });
                        });
                    }
                );
            });
        },
        setupResizing: function(container, config){
            if (!$.fn.resizable) {
                return;
            }

            config = config || {};

            var gridBlockSize = MDB.Charts.dashboardGridSize;

            var box = container.find('.box');

            var baseConfig = {
                minHeight: gridBlockSize,
                minWidth: gridBlockSize,
                handle:'se',
                grid: [gridBlockSize, gridBlockSize],
                start: function(){
                    container.addClass('busy-resizing');
                },
                stop: function () {
                    container.removeClass('busy-resizing');
                    MDB.Charts.showWidgetUpdateAlert();
                }
            };

            //Ensure both stop functions get invoked with the correct arguments
            if(config.stop){
                var configStop = config.stop;
                var baseConfigStop = baseConfig.stop;

                config.stop = function(){
                    baseConfigStop.apply(this, arguments);
                    configStop.apply(this, arguments);
                };
            }

            //Ensure both start functions get invoked with the correct arguments
            if(config.start){
                var configStart = config.start;
                var baseConfigStart = baseConfig.start;

                config.start = function(){
                    baseConfigStart.apply(this, arguments);
                    configStart.apply(this, arguments);
                }
            }

            config = $.extend(baseConfig, config);

            box.resizable(config);
        },

        setupWidgetGroupResizing: function(widgetGroup){
            MDB.Charts.setupResizing(widgetGroup, {
                stop: function(){
                    MDB.Charts.cacheWidgetGroup(widgetGroup);
                }
            });
        },
        setupWidgetResizing: function (widget, config) {
            //return;
            var chart = widget.find('.chart');
            var kendoGrid = chart.find('.kendoGrid');

            MDB.Charts.setupResizing(widget, {
                resize: function() {
                    chart.height(MDB.Charts.calculateKendoChartMaxHeight(widget));

                    if (kendoGrid.length) {
                        kendoGrid = kendoGrid.first().data('kendoGrid');
                        kendoGrid.refresh();
                    } else {
                        kendo.resize(chart);
                    }
                },
                stop: function () {
                    MDB.Charts.cacheWidget(widget);
                }
            });
        },
        setupMoving: function(selector, config){
            if (!$.fn.draggable) {
                return;
            }

            var gridBlockSize = MDB.Charts.dashboardGridSize,
                widgetContainer = $('.widget-container-v2');

            config = config || {};

            var baseConfig = {
                grid: [gridBlockSize, gridBlockSize],
                handle: '.move-handle',
                start: function(){
                    selector.addClass('busy-moving');
                },
                stop: function(){
                    selector.removeClass('busy-moving');
                    MDB.Charts.showWidgetUpdateAlert();
                },
                containment: [
                    widgetContainer.position().left,
                    widgetContainer.position().top,
                    100000,
                    100000
                ]
            };

            //Ensure both stop functions get invoked with the correct arguments
            if(config.stop){
                var configStop = config.stop;
                var baseConfigStop = baseConfig.stop;

                config.stop = function(){
                    baseConfigStop.apply(this, arguments);
                    configStop.apply(this, arguments);
                }
            }

            //Ensure both start functions get invoked with the correct arguments
            if(config.start){
                var configStart = config.start;
                var baseConfigStart = baseConfig.start;

                config.start = function(){
                    baseConfigStart.apply(this, arguments);
                    configStart.apply(this, arguments);
                }
            }

            config = $.extend(baseConfig, config);

            selector.draggable(config);
        },

        setupWidgetGroupMoving: function(widgetGroup){
            MDB.Charts.setupMoving(widgetGroup, {
                stop: function(){
                    MDB.Charts.cacheWidgetGroup(widgetGroup);
                }
            });
        },
        setupWidgetMoving: function (widget, config) {
            MDB.Charts.setupMoving(widget, {
                stop: function(){
                    MDB.Charts.sendWidgetToTop(widget);
                    MDB.Charts.cacheWidget(widget);
                }
            });
        },
        emptyChartAndMakeVisible: function (widget, chart) {
            widget.find('.loading-box').hide();
            chart.empty().show();
            chart.empty().show().height(
                widget.find('.box-primary').height() -
                widget.find('.box-header').outerHeight() -
                widget.find('.ui-icon-gripsmall-diagonal-se').height());
        },
        //Transforms the keys to kendo safe field keys
        transformKeysToKendoFields: function(data, useLegacyTransformation) {
            var keys = Object.keys(data[0]);
            var keyMappings = [];

            keyMappings.findByOriginal = function(og) {
                var result = this.filter(function(km) { return km.originalKey === og; });
                if (result.length > 0) return result[0];
                return undefined;
            };

            keyMappings.findByKey = function(key) {
                var result = this.filter(function(km) { return km.field === key; });
                if (result.length > 0) return result[0];
                return undefined;
            };

            for (var i = 0; i < keys.length; i++) {
                var originalKey = keys[i];

                //var key = keys[i].match(/([a-zA-Z]+)/g) ? "\"" + keys[i] + "\"" : keys[i];
                // always alias them
                var key = keys[i];
                if (!/^[a-zA-Z][a-zA-Z0-9]+$/.test(key)) {
                    // replace invalid chars and ensure that the resulting name is unique
                    keys[i] = key = 'field' +
                        i +
                        '_' +
                        key.replace(/[^a-z0-9]/gi, '_').replace(/^([^a-z]+)(.*)$/gi, '_$2');
                }

                keyMappings[keyMappings.length] = {
                    field: key,
                    originalKey: originalKey
                };
            }
            
            if (useLegacyTransformation === true) {
                //Certain widgets unknowingly depended on this... feature, keep it in for legacy purposes
                data.forEach(function (d) {
                    keyMappings.forEach(function (c) {
                        var ogKey = c.originalKey;
                        var key = c.field;

                        if (key !== ogKey) {
                            d[key] = d[ogKey];
                            delete d[ogKey];
                        }
                    });
                });
            }
            else {
                //Prevent changes to key index by copying the data to a new object
                _.forEach(data, function (ogData, idx) {
                    data[idx] = _.zipObject(keys, _.values(ogData));
                });
            }

            return keyMappings;
        },
        getAggregatedFormatableValues: function (data, keys) {
            //Take the total, max, and key of each key
            //ignore null/undefined values as those serve no use
            //with null even potentially being able to pollute our values
            var formatableValues = keys.map(function(key){
                var values = _.map(data, key).filter(function(value){
                    return value !== null && value !== undefined;
                });
                
                return {
                    key: key,
                    total: _.sum(values),
                    max: _.max(values)
                };
            }, []);
            
            //Create a flat array of all numeric values within our data collection
            var numericValues = _.filter(_.flatMap(_.keys(data), function (k) { 
                return _.values(data[k]); 
            }), _.isNumber);
            
            formatableValues.push({
                key: '__TOTALS__',
                total: _.sum(numericValues),
                max: _.max(numericValues)
            });

            formatableValues.valueFor = function (field, formatType) {
                var fieldValues = _.find(formatableValues, function (t) { return t.key === field; });

                if (!fieldValues || !formatType){
                    return undefined;   
                }
                
                return formatType === 'percentageMax' ?
                    fieldValues.max :
                    fieldValues.total;
            };

            //Can be overwritten for per item based formatting required by certain chart types
            formatableValues.valueForItem = function(field, formatType, item) {
                return formatableValues.valueFor(field, formatType);
            };

            return formatableValues;
        },
        combineWithDefaultTooltipTemplate: function(template, tooltipConfiguration){
            //Override has to be explicitly configured
            if(!tooltipConfiguration || tooltipConfiguration._ignoreDefaultTemplate !== true)
            {
                return MDB.Charts.widgetSeriesTooltipTemplate + template;
            }
            
            return template;
        },
        setLabelFormat: function (target, labelSources, getFormatableValues, field, labelKey, applyExtraFormatting) {
            //Assume key is labels, try to infer field from target
            labelKey = labelKey || 'labels';
            field = field || target.field;
            applyExtraFormatting = applyExtraFormatting || $.noop;
            
            if (!_.isFunction(getFormatableValues)){
                getFormatableValues = _.wrap(getFormatableValues);
            } 

            if (target && target.type === 'date') {
                return;
            }

            labelSources = _.cloneDeep(_.isArray(labelSources) ? labelSources : [labelSources]);
            labelSources.unshift(target);

            _.each(labelSources, function (labelSource) {
                var sourceLabels = labelSource[labelKey];

                //Take target labels, or copy and assign sourceLabels
                var targetLabels = target[labelKey] = target[labelKey] || sourceLabels;

                if (sourceLabels) {
                    if (!target[labelKey] || target[labelKey]._useDefaults) {
                        //'Inherit' format/_formatType
                        if (!targetLabels.format) {
                            targetLabels.format = sourceLabels.format;
                            targetLabels._formatType = sourceLabels._formatType;
                        }

                        if (!targetLabels.culture) {
                            targetLabels.culture = sourceLabels.culture;
                        }
                    }

                    if (target[labelKey]._useDefaults) {
                        targetLabels.background = sourceLabels.background;
                        
                        //Template needs to be hard-inherited from our source, otherwise it'll get overridden later on
                        targetLabels.template = sourceLabels.template;
                        targetLabels._ignoreDefaultTemplate = sourceLabels._ignoreDefaultTemplate;
                    }
                }

                if (targetLabels) {
                    if (sourceLabels.conditionalDisplay && (!targetLabels.conditionalDisplay || targetLabels.conditionalDisplay._useDefaults)) {
                        targetLabels.conditionalDisplay = sourceLabels.conditionalDisplay;
                    }

                    if (sourceLabels.culture && (!targetLabels.culture || targetLabels.culture._useDefaults)) {
                        targetLabels.culture = sourceLabels.culture;
                    }
                }
            });

            var targetLabels = target[labelKey] || {};
            var template = targetLabels.template;

            if (targetLabels) {
                var templateFormatableValue = getFormatableValues().valueFor(field, targetLabels._formatType);
                if (templateFormatableValue) {
                    targetLabels.template = template = sprintf('#= kendo.format(\'%s\', value / %s) #', targetLabels.format, templateFormatableValue);
                }
            }

            var formatResult = applyExtraFormatting(targetLabels, template);
            if (formatResult) {
                targetLabels.template = template = formatResult;
            }

            //Never try to hide tooltips
            if (targetLabels.conditionalDisplay && targetLabels.conditionalDisplay._enableConditionalDisplay && labelKey !== 'tooltip') {
                var percentageConditionalType = undefined;
                var conditionalDisplay = targetLabels.conditionalDisplay;

                if (conditionalDisplay.displayThresholdType === 'PercentageMax')
                    percentageConditionalType = 'percentageMax';

                if (conditionalDisplay.displayThresholdType === 'PercentageTotal')
                    percentageConditionalType = 'percentageTotal';

                var calculateItemThresholdValue = function (item) {
                    return item.value;
                };

                if (percentageConditionalType) {
                    calculateItemThresholdValue = function (item) {
                        var percentage = getFormatableValues().valueForItem(field, percentageConditionalType, item);
                        return ((item.value / percentage) * 100);
                    };
                }

                var shouldDisplayItemLabel = function (item) {
                    return calculateItemThresholdValue(item) >= conditionalDisplay.displayThresholdValue;
                };

                if (!template && targetLabels.format) {
                    template = sprintf('#= kendo.format(\'%s\', value) #', targetLabels.format);
                }

                var kTemplate = kendo.template(template || '#= value #');

                targetLabels.template = function (item) {
                    if (shouldDisplayItemLabel(item)) {
                        return kTemplate(item);
                    }

                    return '';
                };

                var currentBackground = targetLabels.background;
                var isFunctionBackground = _.isFunction(currentBackground);

                targetLabels.background = function (item) {
                    if (shouldDisplayItemLabel(item)) {
                        return isFunctionBackground ? currentBackground.call(item, item) : currentBackground;
                    }

                    return null;
                };
            }

            //Ignore 'undefined' values by default/apply kendo formatting, which ignores undefined by default
            if (!targetLabels.template) {
                if (targetLabels.format && targetLabels.format !== MDB.Charts.pieRawValueFormat) {
                    //Hashes are escaped via a double \\
                    targetLabels.template = kendo.template(sprintf(' #= kendo.format(\'%s\', value) #', targetLabels.format.replace(/#/g, '\\\\#')));
                } else {
                    targetLabels.template = kendo.template(' # if (value !== undefined && value !== null) { # #= value # # } #');

                    // targetLabels.template = function(item){
                    //     if(item.value !== undefined && item.value !== null){
                    //         return item.value;
                    //     }
                    //    
                    //     return '';
                    // };
                }
            }
            
            if (targetLabels.culture) {
                var customCultureOpts = targetLabels.culture;

                var currentCulture = kendo.culture();
                var customSeparatorCulture = _.merge(_.cloneDeep(currentCulture), _.cloneDeep(customCultureOpts));
                customSeparatorCulture.name = 'widget-custom';

                //Worm our way in between the existing template
                var templateFn = _.isFunction(targetLabels.template) ? targetLabels.template : kendo.template(targetLabels.template);

                targetLabels.template = function (obj) {
                    kendo.cultures[customSeparatorCulture.name] = customSeparatorCulture;
                    kendo.culture(customSeparatorCulture.name);

                    try {
                        return templateFn.apply(obj, arguments);   
                    } finally {
                        //Clean any potential leakage
                        kendo.culture(currentCulture.name);
                        delete kendo.cultures[customSeparatorCulture.name];
                    }
                };
            }

            return template;
        },
        initializeLegendClickHandler: function(kendoConfig, callback){
            callback = callback || $.noop;
            
            
            kendoConfig.legendItemClick = function (e) {
                if (!this.options || !this.options.series || e.seriesIndex === undefined){
                    return;
                }

                var kChart = this
                    , chartSeries = kChart.options.series
                    , renderedSeries = _.filter(chartSeries, function (series) { return series.data.length; })
                    , targetSeries = chartSeries[e.seriesIndex]
                    , targets = chartSeries
                    , renderedTargets = renderedSeries
                    , targetIndex = e.seriesIndex; 
                
                var shouldApplyFilter = renderedSeries.length > 1
                    , isDataPoint = e.pointIndex !== undefined;
                
                if (isDataPoint){
                    targets = targetSeries.data;
                    renderedTargets = targets;
                    
                    targetIndex = e.pointIndex;

                    shouldApplyFilter = shouldApplyFilter || renderedSeries.length === 1 && targetSeries.data.length > 1;
                }

                //No point in filtering when only a single item is present
                if (!shouldApplyFilter){
                    e.preventDefault();
                    return;
                }
                
                //Both undefined and true are considered visible
                var visibleTargets = _.filter(renderedTargets, function (target) { return target.visible !== false; });
                var isCustomVisibilitySetter = false;
                
                var newVisibleTargets = [];

                //When only one target is visible and selected/two targets are visible and the other is selected, show all targets
                if (visibleTargets.length === 1 && (renderedTargets.length === 2 || targets.indexOf(visibleTargets[0]) === targetIndex)){
                    isCustomVisibilitySetter = true;

                    _.forEach(targets, function (target) {
                        target.visible = true;
                        newVisibleTargets.push(target);
                    });
                }

                //When all targets are visible, show only the selected targets
                if (visibleTargets.length === renderedTargets.length){
                    isCustomVisibilitySetter = true;

                    _.forEach(targets, function(target, index){
                        target.visible = index === targetIndex;
                        
                        if (target.visible){
                            newVisibleTargets.push(target);
                        } 
                    });
                }
                
                if (!isCustomVisibilitySetter){
                    newVisibleTargets = visibleTargets;
                    
                    //We have to manually add/remove depending on the action being taken 
                    if (targets[targetIndex].visible){
                        if (newVisibleTargets.indexOf(targets[targetIndex]) !== -1){
                            newVisibleTargets.splice(newVisibleTargets.indexOf(targets[targetIndex]), 1);
                        }
                    } 
                    else {
                        newVisibleTargets.push(targets[targetIndex]);
                    }
                } 
                
                callback(newVisibleTargets);
                
                if (isCustomVisibilitySetter){
                    e.preventDefault();
                    kChart.redraw();
                }
            }
        },
        setKendoClickHandler: function(kendoConfig, widget, getJsonData){
            if(!kendoConfig || !kendoConfig.seriesDefaults || !kendoConfig.seriesDefaults.clickConfig){
                return;
            }
            
            
            var canClickProm = MDB.Security.validatePermission(MDB.Security.Permissions.WidgetClickExecuteStoredProcedure);
            var clickConfig = kendoConfig.seriesDefaults.clickConfig;
            var widgetId = widget.data('id');

            kendoConfig.seriesClick = function(e){
                var args = arguments;
                var thisArg = this;
                
                canClickProm.done(function(){
                    var jsonData = getJsonData.apply(thisArg, args);
                    
                    $.Deferred(function(def){
                        if(!clickConfig.confirmationText){
                            def.resolve();
                            return;
                        }

                        var body = clickConfig.confirmationText;

                        Object.keys(jsonData).forEach(function(key){
                            body = body.replace(new RegExp('\\${' + key + '}', 'g'), jsonData[key]);
                        });

                        MDB.prompt(
                            undefined,
                            body,
                            function(ok){
                                if(ok){
                                    def.resolve();
                                }
                            }
                        )
                    })
                    .done(function(){
                        $.ajax({
                            url: '/Widget/HandleSeriesClick',
                            method: 'POST',
                            data: {
                                dashboardId: MDB.Charts.activeDashboardId,
                                divisionId: MDB.isGuid(MDB.Charts.divisionId) ? MDB.Charts.divisionId : MDB.CurrentUser.DivisionId,
                                widgetId: widgetId,
                                SerializedJsonData: JSON.stringify(jsonData),
                                dashboardFilters: MDB.Charts.getWidgetArraySerializedFilters(widget)
                            }
                        }).error(function(xhr, status, message){
                            message = message || MDB.loadResourceString('Marketingdb_Ajax_Request_Server_Error_Text');
                            
                            MDB.alert(message);
                        }).done(function(res){
                            //Don't waste resources by reloading the dashboard when a forward URL is provided anyways
                            if(!res.forwardURL && res.refreshDashboard === true){
                                MDB.Charts.refreshAllWidgets();
                            }

                            $.Deferred(function(def){
                                if(!res.text){
                                    def.resolve();
                                    return;
                                }

                                MDB.alert(res.text, undefined, {
                                    'hidden.bs.modal': function(){
                                        def.resolve();
                                    }
                                });
                            }).done(function(){
                                if(res.forwardURL){
                                    if(res.forwardURLTarget){
                                        window.open(res.forwardURL, res.forwardURLTarget);
                                    }
                                    else{
                                        window.location.assign(res.forwardURL);
                                    }
                                }
                            });
                        });
                    });
                });
            }
        },
        setCategoryAxisWeekDisplayToWeekNumbers: function (kendoConfig) {
            //Moment ISO week number
            var weekFormat = 'W';
            
            if (!kendoConfig.categoryAxis) kendoConfig.categoryAxis = {};
            if (!kendoConfig.categoryAxis.labels) kendoConfig.categoryAxis.labels = {};
            if (!kendoConfig.categoryAxis.labels.dateFormats) kendoConfig.categoryAxis.labels.dateFormats = {};

            if (!kendoConfig.categoryAxis.categoryAxisType || kendoConfig.categoryAxis.categoryAxisType === 'date'){
                var defaultTemplate = kendoConfig.categoryAxis.labels.template || '#= kendo.toString(value, format) #';

                kendoConfig.categoryAxis.labels.dateFormats.weeks = weekFormat;
                kendoConfig.categoryAxis.labels.template = '# if(value instanceof Date && format === "'+ weekFormat + '") {# #= moment(value).format(format) # #} else {# ' + defaultTemplate + ' #}# ';
            }
            
            return kendoConfig;
        },
        getColumnAliasses: function (widget) {
            if (widget && widget.data) {
                try {
                    var tmp = widget.data('titles');
                    if (tmp)
                        return JSON.parse(tmp);
                } catch (e) {
                    console.error('Error parsing widget aliases');
                    console.error(e.stack);
                }
            }

            return {};
        },
        embedColorsInData: function(data, palette){
            if (!palette || !_.isArray(palette)){
                return;
            } 
            
            var colorKey = MDB.Charts.getDataColorKey(data[0]) || 'color';
            
            _.forEach(data, function (d, i) {
                //If a color has already been specified in the dataset, use that to override the palette color
                d[colorKey] = d[colorKey] || palette[i % palette.length];
            });
        },
        getDataColorKey: function(data){
            var defaultColorKey = 'color';
            
            if (_.isObject(data) && !_.isArray(data)){
                data = Object.keys(data);
            } 
            
            return data.indexOf(defaultColorKey) !== -1 ? defaultColorKey : undefined;
        },
        getDataKeys: function (data) {
            var keyArr = Object.keys(data);
            var colorKey = MDB.Charts.getDataColorKey(keyArr);
            
            if (colorKey){
                keyArr.splice(keyArr.indexOf(colorKey), 1);
            }
                
            return keyArr;
        },
        setupWidgetFramedModalTrigger: function() {
            $('.widget-container-v2').on('click', '.widget.dashboard-widget .widget-modal-popup', function (e) {
                e.preventDefault();

                var me = $(this);

                var url = me.data('url');

                if (me.hasClass('widget-dashboard-modal-popup')) {
                    var params = {
                        embedded: true,
                        selectedDivisionId: MDB.Charts.divisionId || null,
                        startDate: MDB.Charts.dateStart || null,
                        endDate: MDB.Charts.dateEnd || null
                    };
                    url += url.indexOf('?') === -1 ? '?' : '&';
                    url += $.param(params);
                    url = MDB.Charts.appendActiveFiltersToUrl(url);
                }

                MDB.displayInModalFrame(url);
            });
        },
        createContinuousPaletteBasedColorGenerator: function(palette){
            /*
                Only reset current color after having looped over the complete palette
                kendo by default resets the color on a per series basis
            */
            
            var currentIndex = 0;
            var maxIndex = palette.length;

            return function () {
                if(currentIndex >= maxIndex){
                    currentIndex = 0;
                }
                
                var color = palette[currentIndex];
                currentIndex++;
                
                return color;
            }
        },
        createColorGenerator: function(){
            //DPN-1776
            var scale = chroma.scale('Spectral');
            var cache = {};

            //https://stackoverflow.com/a/52171480/3697715
            var cyrb53 = function(str, seed) {
                if(seed === undefined){
                    seed = 0;
                }

                var h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
                for (var i = 0, ch; i < str.length; i++) {
                    ch = str.charCodeAt(i);
                    h1 = (h1 ^ ch) * 2654435761;
                    h2 = (h2 ^ ch) * 1597334677;
                }
                h1 = ((h1 ^ h1>>>16) * 2246822507) ^ ((h2 ^ h2>>>13) * 3266489909);
                h2 = ((h2 ^ h2>>>16) * 2246822507) ^ ((h1 ^ h1>>>13) * 3266489909);
                return 4294967296 * (2097151 & h2) + (h1>>>0);
            };

            return function(str){
                if(cache[str]){
                    return cache[str];
                }

                //Hacky way to get float representation between 0 and 1
                //Needed for chroma.js
                var floatRep = parseFloat('0.' + cyrb53(str));

                return cache[str] = scale(floatRep).hex();
            }
        },
        parseTableLegend: function (kendoConfig, keys, aliasses) {
            var tableLegend = kendoConfig.legend || [];
            tableLegend.legendFor = function (idx) {
                var legendItem = _.find(tableLegend, { columnIndex: idx });
                if (!legendItem) {
                    if (tableLegend[idx] && tableLegend[idx].columnIndex === undefined) {
                        legendItem = tableLegend[idx];
                    }
                }

                return legendItem;
            };

            tableLegend.getHeaderText = function (idx) {
                var legendItem = tableLegend.legendFor(idx);
                if (legendItem && legendItem.displayName)
                    return legendItem.displayName;

                return aliasses[keys[idx]] || keys[idx] || '';
            };

            tableLegend.getTooltipText = function (idx) {
                var legendItem = tableLegend.legendFor(idx);
                return (legendItem && legendItem.tooltip) ? legendItem.tooltip : undefined;
            };

            tableLegend.getIconFontSize = function(idx) {
                var legendItem = tableLegend.legendFor(idx);
                return (legendItem && legendItem.tooltip) ? legendItem.tooltipIconFontSize + 'px' : undefined;
            };

            tableLegend.getStyle = function(idx) {
                var legendItem = tableLegend.legendFor(idx);
                if (legendItem) {
                    return {
                        'background-color': legendItem.color
                    }
                }

                return {};
            };
            
            tableLegend.isAudio = function(idx) {
                var legendItem = tableLegend.legendFor(idx);
                return (legendItem && legendItem.columnType === 'Audio');
            }
            
            tableLegend.getFormat = function(idx){
                var legendItem = tableLegend.legendFor(idx);
                return legendItem ? legendItem.format : undefined;
            };
            
            return tableLegend;
        }
    });
})(jQuery, window);
